import { render } from "./Reports.vue?vue&type=template&id=1445d571&scoped=true"
import script from "./Reports.vue?vue&type=script&lang=js"
export * from "./Reports.vue?vue&type=script&lang=js"

import "./Reports.vue?vue&type=style&index=0&id=1445d571&scoped=true&lang=css"
import "./Reports.vue?vue&type=style&index=1&id=1445d571&lang=css"

import exportComponent from "../../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1445d571"]])

export default __exports__